// extracted by mini-css-extract-plugin
module.exports = {"selectedIcon":"style-module_selectedIcon__12QvTMC6w_ON8ULEJn2Od_","buttons":"style-module_buttons__3i_fKnq4eGxZRc1fTGEHo3"};